import { FC } from "react";

import { CHEVRON_RIGHT_ICON_PATHS } from "../utils/icon-paths";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ChevronRightIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    {CHEVRON_RIGHT_ICON_PATHS.map((d, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <path d={d} fill="currentColor" key={i} />
    ))}
  </svg>
);
